export function shipmentIndexValidate(shipment){
    var result = true;

    result = validateId(shipment.id);
    if(!result) return "id";
    
    result = validateUniqueOrderNumber(shipment.unique_order_number);
    if(!result) return "unique_order_number";

    result = validateShipmentNumber(shipment.shipment_number);
    if(!result) return "shipment_number";

    result = validateShippingService(shipment.shipping_service);
    if(!result) return "shipping_service";

    result = validateTotal(shipment.total);
    if(!result) return "total";

    result = validateDate(shipment.date);
    if(!result) return "date";

    result = validateClient(shipment.client);    

    return result;
}

function validateId(id) {    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateUniqueOrderNumber(unique_order_number) {
    if(typeof unique_order_number === 'string' && unique_order_number.trim() !== '') return true;
    else return false;
}

function validateShipmentNumber(shipment_number) {
    if((typeof shipment_number === 'string' && shipment_number.trim() !== '') || shipment_number == null || shipment_number == undefined) return true;
    else return false;
}

function validateShippingService(shipping_service) {
    if((typeof shipping_service === 'string' && shipping_service.trim() !== '') || shipping_service == undefined) return true;
    else return false;
}

function validateTotal(total) {
    if(typeof total === 'number' || total == undefined) return true;
    else return false;
}

function validateDate(date) {
    if(typeof date === 'string' && date.trim() !== '' || date == undefined) return true;
    else return false;
}

function validateClient(client) {
    return (typeof client === 'object'
        && Number.isInteger(client.id)
        && typeof client.name === 'string' 
        && client.name.trim() !== ""
    )
}